import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Languages } from 'lucide-react';

const LanguageSupport: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#011E26] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Language Support</h1>
                    <p className="text-xl text-slate-300 max-w-2xl">
                        Mastering the language skills essential for international success.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <Languages className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Expert Coaching for Efficiency</h2>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        Strong English language skills are essential for success in international education. At Nex Overseas, our Language Support programs help students develop the proficiency they need to excel academically and achieve their target test scores.
                    </p>

                    <h3 className="text-2xl font-serif text-[#011E26] mb-4">Expert Coaching for Major Tests</h3>
                    <p className="mb-4">
                        We provide expert coaching for major English proficiency tests, including:
                    </p>
                    <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                        {['IELTS', 'TOEFL', 'Duolingo English Test', 'PTE'].map((test, i) => (
                            <li key={i} className="bg-gray-50 border border-gray-200 p-4 rounded text-center font-bold text-[#009B8F] shadow-sm">
                                {test}
                            </li>
                        ))}
                    </ul>

                    <p className="mb-4">
                        Our programs are designed to strengthen all key language areas: reading, writing, listening, and speaking. Students receive personalised coaching, regular practice assessments, and guidance to improve their overall performance and reach their desired band scores.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">Services We Offer:</h3>
                        <ul className="space-y-2">
                            {[
                                "Language assessment and personalized study plans",
                                "Exam-focused preparation for IELTS, TOEFL, Duolingo, and PTE",
                                "Regular practice tests with performance feedback",
                                "Academic communication and writing support"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-8">
                        With Nex Overseas, students gain the confidence and skills needed to excel in their exams and succeed in academic environments abroad.
                    </p>

                    <p className="mb-8 font-medium text-[#011E26]">
                        Get in touch today to learn more about our Language Support programs.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Contact Us
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LanguageSupport;
